import { Injectable } from '@angular/core';

import { AppDomService } from './app-dom.service';
import { IEnterEmailDialogConfig, IEnterEmailDialogResult } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class EnterEmailModalDialogService {
    private readonly selectors = {
        dialogTitle: '[aza-rws-enter-email-title-text]',
        modalDialogOverlay: '[aza-rws-modal-dialog-overlay]',
        modalDialog: '[aza-rws-enter-email-dialog]',
        cancelButton: '[aza-rws-modal-dialog-first-button]',
        proceedButton: '[aza-rws-modal-dialog-second-button]',
        email: '[aza-rws-enter-email-email]',
        emailErrorText: '[aza-rws-enter-email-email-error-text-container]'
    };

    constructor(private readonly appDomSvc: AppDomService) {
    }

    async showPopupDialog(config: IEnterEmailDialogConfig): Promise<IEnterEmailDialogResult> {
        const titleEl = document.querySelector(this.selectors.dialogTitle) as HTMLElement;
        titleEl.innerText = config.title;
        const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
        const modalDialogEl = document.querySelector(this.selectors.modalDialog);
        this.appDomSvc.showElementWithCss(modalDialogOverlayEl);
        this.appDomSvc.showElementWithCss(modalDialogEl);
        const emailErrorTextEl = modalDialogEl.querySelector(this.selectors.emailErrorText) as HTMLElement;
        this.appDomSvc.hideElementWithCss(emailErrorTextEl);
        const emailCodeEl = modalDialogEl.querySelector(this.selectors.email) as HTMLInputElement;
        emailCodeEl.value = '';
        const promise = new Promise<IEnterEmailDialogResult>((resolve, reject) => {
            const cancelBtnEl = modalDialogEl.querySelector(this.selectors.cancelButton) as HTMLDivElement;
            const proceedBtnEl = modalDialogEl.querySelector(this.selectors.proceedButton) as HTMLButtonElement;
            proceedBtnEl.disabled = true;
            emailCodeEl.oninput = ev => {
                const isEmailValid = this.isEmailValid(emailCodeEl.value);
                this.appDomSvc.changeElementVisibilityWithCss(emailErrorTextEl, !isEmailValid);
                proceedBtnEl.disabled = !isEmailValid;
            };
            cancelBtnEl.onclick = () => resolve(null);
            proceedBtnEl.onclick = () => {
                resolve({ email: emailCodeEl.value });
            };
        });
        return promise;
    }

    private isEmailValid(value: string): boolean {
        if (!value || !value.trim()) {
            return false;
        }

        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const trimmedEmail = value.trim();
        const isValid = regex.test(trimmedEmail);
        return isValid;
    }

    hidePopupDialog(): void {
        const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
        const modalDialogEl = document.querySelector(this.selectors.modalDialog);
        this.appDomSvc.hideElementWithCss(modalDialogOverlayEl);
        this.appDomSvc.hideElementWithCss(modalDialogEl);
        const emailCodeEl = modalDialogEl.querySelector(this.selectors.email) as HTMLInputElement;
        emailCodeEl.value = '';
    }
}
